import { Filter, Search, X } from 'lucide-react';
import { Tooltip } from './Tooltip';

export const FilterSection = ({
  filters = [],
  onFilterChange,
  onClearFilters,
  searchValue = '',
  searchPlaceholder = "Search...",
  showSearch = true
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Filter className="w-5 h-5 text-gray-500" />
          <h3 className="font-semibold text-gray-900">Filters</h3>
        </div>
        {onClearFilters && (
          <button
            onClick={onClearFilters}
            className="text-sm text-blue-600 hover:text-blue-700 flex items-center gap-1 transition-colors"
          >
            <X className="w-4 h-4" />
            Clear all
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search Input */}
        {showSearch && (
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" />
            <input
              type="search"
              placeholder={searchPlaceholder}
              value={searchValue}
              className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              onChange={(e) => onFilterChange('search', e.target.value)}
            />
          </div>
        )}

        {/* Dynamic Filters */}
        {filters.map(filter => (
          <div key={filter.name} className="flex items-center gap-2">
            <select
              value={filter.value || 'all'}
              onChange={(e) => onFilterChange(filter.name, e.target.value)}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
            >
              <option value="all">All {filter.label}</option>
              {filter.options.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
            {filter.tooltip && <Tooltip content={filter.tooltip} />}
          </div>
        ))}
      </div>
    </div>
  );
};
